import {Directive, forwardRef, Inject} from '@angular/core';
import {NG_VALUE_ACCESSOR} from '@angular/forms';
import {
  IdentityCardNumber,
  IdentityCardNumberFormatter,
  isValidIdentityCardNumber,
} from '@atlas/businesstypes';

import {
  ATLAS_VALUE_ACCESSOR,
  AtlasControlValueAccessor,
  BaseBusinesstypeDirective,
} from '../base/index';

/**
 * @ngModule BusinessTypesModule
 */
@Directive({
  selector: '[atlasIdentityCardNumber]',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => IdentityCardNumberDirective),
    },
  ],
})
export class IdentityCardNumberDirective extends BaseBusinesstypeDirective {
  public constructor(@Inject(ATLAS_VALUE_ACCESSOR) input: AtlasControlValueAccessor) {
    super(input);
  }

  public writeValue(value?: IdentityCardNumber | string): void {
    this._input.writeValue(
      IdentityCardNumber.isIdentityCardNumber(value)
        ? IdentityCardNumberFormatter.format(value)
        : value == null
        ? ''
        : value,
    );
  }

  public registerOnChange(fn: (_: IdentityCardNumber | string | null) => void): void {
    this._input.registerOnChange(value => {
      if (value === '') {
        fn(null);
        return;
      }

      const unformatted = IdentityCardNumberFormatter.unformat(value);
      fn(
        isValidIdentityCardNumber(unformatted) ? new IdentityCardNumber(unformatted) : unformatted,
      );
    });
  }
}
